import { useState } from 'react';
import openai from '../config/openaiConfig';

const useOpenAI = () => {
  
  const [imageURLs, setImageURLs] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const generateImage = async (prompt) => {
    setLoading(true);
    setError(null);
    // console.log("propmpt is : ", prompt)
    try {
      const response = await openai.createImage({
        prompt,
        n: 4,
        size: '1024x1024',
      });

      const imageUrls = response.data.data.map((imageData) => imageData.url);
      setImageURLs(imageUrls);
    } catch (error) {
      setError('An error occurred while generating the images.');
      console.error(error);
    }

    setLoading(false);
  };

  return {
    
    imageURLs,
    loading,
    error,
    generateImage,
  };
};

export default useOpenAI;
